<template>
  <div class="errorWrapper">
    <img class="errorImg" width="820" height="451" src="../assets/images/error.png" alt="">
    <div class="tip">你访问的页面不存在或已删除</div>
    <div class="backTip">即将离开本页,<span class="red">{{time}}</span>秒后自动返回上一页</div>
    <button class="goIndex" @click="goIndex">返回首页</button>
  </div>
</template>

<script>
  import {store} from '../store/store';
  export default {
    name: 'error',
    data() {
      return {
        time: 3,
        timer: null
      }
    },
    beforeRouteLeave(to, from, next) {
      if(!to.name) {   /*防止手动更改url*/
        history.go(-1)
      }
      if(this.timer) {
        clearInterval(this.timer)
      }
      next()
    },
    mounted() {
      clearInterval(this.timer)
      this.timer = setInterval(()=>{
        this.time --;
        if(this.time === 0) {
          history.go(-1)
          clearInterval(this.timer)
        }
      },1000)
    },
    methods: {
      goIndex() {
        clearInterval(this.timer)
        this.$router.push('/');
      }
    }
  }
</script>

<style scoped>
  .errorWrapper {
    padding-top: 50px;
    height: 730px;
    text-align: center;
  }

  .tip {
    font-size: 24px;
    line-height: 24px;
    color: #333;
  }

  .backTip {
    margin-top: 20px;
    margin-bottom: 34px;
    font-size: 14px;
    color: #999;
  }

  .goIndex {
    margin-bottom: 137px;
    width: 160px;
    height: 45px;
    background: #cb7629;
    font-size: 14px;
    color: #fff;
    border: none;
    border-radius: 4px;
  }
</style>
